import { createWorker, OEM, PSM } from "tesseract.js";

import { extractGridCandidates } from "./candidates";
import type {
  GridRecognitionProgress,
  GridRecognitionResult,
  LocalOcrAssetUrls,
} from "./types";

export function localOcrAssetUrls(baseUrl: string): LocalOcrAssetUrls {
  const base = new URL("./", baseUrl);
  return {
    workerPath: new URL("vendor/tesseract/worker.min.js", base).href,
    corePath: new URL("vendor/tesseract/core/", base).href,
    langPath: new URL("vendor/tesseract/lang", base).href.replace(/\/$/, ""),
  };
}

export async function recognizeTraceGridCandidates(
  image: File,
  onProgress: (progress: GridRecognitionProgress) => void = () => undefined,
): Promise<GridRecognitionResult> {
  const assets = localOcrAssetUrls(document.baseURI);
  const worker = await createWorker("eng", OEM.LSTM_ONLY, {
    ...assets,
    gzip: true,
    logger: ({ progress, status }) => onProgress({ progress, status }),
    workerBlobURL: false,
  });
  try {
    await worker.setParameters({
      preserve_interword_spaces: "1",
      tessedit_char_whitelist: "0123456789GRgrIDid- ,./",
      tessedit_pageseg_mode: PSM.SPARSE_TEXT,
    });
    const { data } = await worker.recognize(image);
    return {
      candidates: extractGridCandidates(data.text),
      confidence: data.confidence,
    };
  } finally {
    await worker.terminate();
  }
}
